import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import api from '../api';
import { useAuth } from '../components/AuthContext';

const DEFAULTS = { shopping: true };
const ModulesContext = createContext({ modules: DEFAULTS, setModules: () => {} });

// Globale Modul-Schalter (Admin-Bereich). Standard: alle Module aktiv.
export function ModulesProvider({ children }) {
  const { user } = useAuth();
  const [modules, setModulesState] = useState(DEFAULTS);

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    api.get('/api/settings/modules')
      .then((res) => { if (!cancelled) setModulesState({ ...DEFAULTS, ...res.data }); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [user]);

  const setModules = useCallback((next) => setModulesState((prev) => ({ ...prev, ...next })), []);
  const value = useMemo(() => ({ modules, setModules }), [modules, setModules]);
  return <ModulesContext.Provider value={value}>{children}</ModulesContext.Provider>;
}

export const useModules = () => useContext(ModulesContext);
